import React, { useState, useRef, useEffect } from 'react';

import { Input, useT } from '@repo/common';
import PostSection from '../PostSection';
import usePlaceholder from '../usePlaceholder';
import VisaTypeList from './VisaTypeList';
import PostRadioGroup from '../PostRadioGroup';

import { ReactComponent as ArrowBottomIcon } from '@repo/common/assets/icons/20px/icon_20px_arrow-bottom.svg';
import { ReactComponent as ArrowTopIcon } from '@repo/common/assets/icons/20px/icon_20px_arrow-top.svg';

const VisaAndEligibility = ({
  textValues,
  setTextValues,
  errors,
  visaTypeOptions,
}) => {
  const t = useT();
  const ph = usePlaceholder();
  const [isVisaOpen, setIsVisaOpen] = useState(false);
  const selectedVisaTypes = Array.isArray(textValues.visaTypes)
    ? textValues.visaTypes
    : [];

  const refs = useRef({
    visaType: null,
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        refs.current.visaType &&
        !refs.current.visaType.contains(event.target)
      ) {
        setIsVisaOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <PostSection title={t('Visa & Eligibility', '비자 및 지원 자격')}>
      <div ref={(el) => (refs.current.visaType = el)} className='relative'>
        <Input
          data-validation-field='visaTypes'
          label={t('Eligible visa type*', '지원 가능 비자*')}
          value={selectedVisaTypes.join(', ')}
          state={errors.visaTypes ? 'failed' : 'default'}
          showStatusIcon={false}
          message={errors.visaTypes}
          placeholder={ph(
            t('Select eligible visa type', '지원 가능 비자를 선택하세요'),
          )}
          rightIcon={
            isVisaOpen ? (
              <ArrowTopIcon className='text-icon-placeholder' />
            ) : (
              <ArrowBottomIcon className='text-icon-placeholder' />
            )
          }
          readOnly
          onClick={() => setIsVisaOpen((prev) => !prev)}
          onRightIconClick={() => setIsVisaOpen((prev) => !prev)}
        />
        {isVisaOpen && (
          <div className='absolute left-0 z-20 w-full mt-1 top-full'>
            <VisaTypeList
              options={visaTypeOptions}
              selectedOptions={selectedVisaTypes}
              onToggle={(option) => {
                setTextValues((prev) => ({
                  ...prev,
                  visaTypes:
                    option === 'Any'
                      ? prev.visaTypes?.includes('Any')
                        ? []
                        : ['Any']
                      : prev.visaTypes?.includes(option)
                        ? prev.visaTypes.filter(
                            (visaType) => visaType !== option,
                          )
                        : [
                            ...(prev.visaTypes || []).filter(
                              (visaType) => visaType !== 'Any',
                            ),
                            option,
                          ],
                }));
              }}
            />
          </div>
        )}
      </div>

      <PostRadioGroup
        label={t('Visa sponsorship', '비자 스폰서십')}
        required
        value={textValues.visaSponsorship}
        onChange={(value) => {
          setTextValues((prev) => ({
            ...prev,
            visaSponsorship: value,
          }));
        }}
        options={[
          { value: 'yes', label: t('Yes', '예') },
          { value: 'no', label: t('No', '아니요') },
        ]}
      />

      {/*
        'Overseas applicants accepted' 입력은 Requirements 의 'Korea residents only' 로 통합됐다.
        (false = Overseas applicants accepted)
      */}

      {/* 국적 입력은 Requirements 섹션 하나로 통합 (여기 있던 자유 입력란 제거) */}
    </PostSection>
  );
};

export default VisaAndEligibility;
